import { PropsWithChildren, useId } from 'react'
import { range } from 'src/utils'
import './Loader.css'

interface Props {
  isLoading: boolean
}

export const MainLoader = ({
  children,
  isLoading = false,
}: PropsWithChildren<Props>) => {
  const key = useId()
  return isLoading ? (
    <div className='w-full h-full flex-center'>
      <span className='w-[57px] text-[0px] inline-block'>
        {range(0, 9).map((_, index) => (
          <span
            key={key + index}
            className={`inline-block bg-primary-yellow w-[15px] h-[15px] m-[2px] text-white rounded-full grid-loader-${
              index + 1
            }`}
          />
        ))}
      </span>
    </div>
  ) : (
    children
  )
}

export default MainLoader
